var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.543,
    height: 22.543,
    viewBox: "0 0 22.543 22.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "categories",
    d: "M16.259,8.683v5.892a1.683,1.683,0,0,1-1.683,1.683H8.683A1.683,1.683,0,0,1,7,14.576V8.683A1.683,1.683,0,0,1,8.683,7h5.892A1.683,1.683,0,0,1,16.259,8.683ZM26.36,7H20.468a1.683,1.683,0,0,0-1.683,1.683v5.892a1.683,1.683,0,0,0,1.683,1.683H26.36a1.683,1.683,0,0,0,1.683-1.683V8.683A1.683,1.683,0,0,0,26.36,7ZM14.576,18.784H8.683A1.683,1.683,0,0,0,7,20.468V26.36a1.683,1.683,0,0,0,1.683,1.683h5.892a1.683,1.683,0,0,0,1.683-1.683V20.468A1.683,1.683,0,0,0,14.576,18.784Zm8.838,0a4.63,4.63,0,1,0,4.63,4.63,4.63,4.63,0,0,0-4.63-4.63Z",
    transform: "translate(-6.25 -6.25)",
    fill: "#fff",
    stroke: "#a6a6a6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.1c824ec30dfe6ce98bd9a1bd682cd02e.svg";
export { ForwardRef as ReactComponent };